import './BackgroundLayout.css';

export default function BackgroundLayout({ children }) {
  return (
    <div className="background-layout">
      <div className="background-layout__glow" aria-hidden="true" />
      <div className="background-layout__content">{children}</div>
    </div>
  );
}
